import { render, staticRenderFns } from "./configuraciongeneral.vue?vue&type=template&id=d19d16b2"
import script from "./configuraciongeneral.vue?vue&type=script&lang=js"
export * from "./configuraciongeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports